import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataDialogsFormWidget: null,
  activeDialogFormWidget: null,
  newDialogFormWidget: null,
  updateDialogFormWidget: null,
};

const dialogFormWidgetSlice = createSlice({
  name: "dialogFW",
  initialState,
  reducers: {
    setDataDialogsFW(state, action) {
      state.dataDialogsFormWidget = action.payload;
    },
    setActiveDialogsFW(state, action) {
      state.activeDialogFormWidget = action.payload;
    },
    setNewDialogsFW(state, action) {
      state.newDialogFormWidget = action.payload;
    },
  },
});

export const { setDataDialogsFW, setActiveDialogsFW, setNewDialogsFW } =
  dialogFormWidgetSlice.actions;
export default dialogFormWidgetSlice.reducer;
